<template>
  <v-container>
    <v-form @submit.prevent="submit">
      <device-picker @input="setDevice">
        <template v-slot:activator="{ on }">
          <v-text-field label="차량" readonly v-on="on" :value="device"></v-text-field>
        </template>
      </device-picker>
      <driver-selector v-slot="{ items, loading, error }">
        <v-select
          v-model="plan._drv"
          :items="items"
          :loading="loading"
          label="운전자"></v-select>
      </driver-selector>
      <date-picker label="운행일" v-model="date"></date-picker>
      <v-select label="시" v-model="hour" :items="range(24)"></v-select>
      <v-select label="분" v-model="minute" :items="range(60)"></v-select>
      <v-btn type="submit" color="success">{{ submitText }}</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { getPlan, updatePlan, createPlan } from '@/api'
import driverSelector from './driver-selector'
import devicePicker from './device-picker'

import range from 'lodash/range'

export default {
  components: {
    driverSelector,
    devicePicker
  },
  props: {
    new: {
      type: Boolean,
      default: false
    }
  },
  async beforeRouteEnter (to, from, next) {
    const _id = to.params._id

    if (!_id) return next()

    try {
      const query = {
        populate: 'group device driver'
      }
      const plan = await getPlan(_id, query)
      next(vm => {
        Object.assign(vm.$data.plan, plan)
      })
    } catch (err) {
      console.error(err.message)
      next()
    }
  },
  data () {
    return {
      plan: {
        startDate: this.$moment().format('YYYY-MM-DD'),
        _gr: null,
        _dv: null,
        _drv: null,
        device: {
          info: {
            plateNo: ''
          }
        },
        group: {
          name: ''
        }
      }
    }
  },
  computed: {
    device () {
      if (!this.plan.device.info.plateNo) return null
      return `${this.plan.device.info.plateNo} (${this.plan.group.name})`
    },
    startDate () {
      return this.$moment(this.plan.startDate)
    },
    date: {
      get () {
        return this.startDate.format('YYYY-MM-DD')
      },
      set (str) {
        const moment = this.$moment(str, 'YYYY-MM-DD')
        const year = moment.year()
        const month = moment.month()
        const day = moment.date()

        this.plan.startDate = this.$moment(this.plan.startDate)
          .set('year', year)
          .set('month', month)
          .set('date', day)
      }
    },
    hour: {
      get () {
        return this.startDate.hour()
      },
      set (num) {
        this.plan.startDate = this.$moment(this.plan.startDate)
          .set('hour', num)
      }
    },
    minute: {
      get () {
        return this.startDate.minute()
      },
      set (num) {
        this.plan.startDate = this.$moment(this.plan.startDate)
          .set('minute', num)
      }
    },
    submitText () {
      return this.new ? '만들기' : '적용'
    }
  },
  methods: {
    range,
    setDevice (device) {
      this.plan._dv = device._id
      this.plan.device.info.plateNo = device.plateNo
      this.plan._gr = device._gr
      this.plan.group.name = device.group
    },
    async submit () {
      if (this.loading) return
      this.loading = true
      try {
        const $promise = this.plan.hasOwnProperty('_id') ? updatePlan(this.plan._id, this.plan) : createPlan(this.plan)
        await $promise
        alert('성공')
        this.$router.go(-1)
      } catch (err) {
        alert(err.message)
      }

      this.loading = false
    }
  }
}
</script>
